module.exports = __webpack_public_path__ + "static/media/exit_to_app.1e370eef.svg";